import React from 'react'
import { splitQuotedText } from '@packages/chat'
import type { CSSObject } from '@emotion/react'

type MentionedUser = { id?: string; name?: string }

type Props = {
  text: string
  textCss: CSSObject | CSSObject[]
  linkCss: CSSObject | CSSObject[]
  mentionCss?: CSSObject | CSSObject[]
  mentionedUsers?: MentionedUser[]
  numberOfLines?: number
}

// @spec FR-0077/AC-6@v1 — web renderer over `splitQuotedText`; non-interactive (parent tile is the click target).
export const QuotedTextWithLinks = ({ text, textCss, linkCss, mentionCss, mentionedUsers, numberOfLines }: Props) => {
  const parts = splitQuotedText(text, mentionedUsers)
  const clamp = numberOfLines
    ? {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical' as const,
        WebkitLineClamp: numberOfLines,
        overflow: 'hidden',
      }
    : undefined

  return (
    <span css={[textCss, clamp]}>
      {parts.map((part, index) => {
        if (part.kind === 'text') {
          return <React.Fragment key={`text-${index}`}>{part.value}</React.Fragment>
        }
        const css = part.kind === 'mention' ? (mentionCss ?? linkCss) : linkCss
        return (
          <span key={`${part.kind}-${index}`} css={css}>
            {part.value}
          </span>
        )
      })}
    </span>
  )
}
